import ReactSlider from "react-slider";
import styles from "./SliderPianificazione.module.css";
import React from "react";
import classNames from "classnames";

export const SliderPianificazione2: React.FC<{ setFlags: (value: number) => void }> = ({setFlags}) => {
    {/*https://codesandbox.io/embed/simple-react-slider-56gsb?fontsize=14&hidenavigation=1&theme=dark*/
    }
    return <ReactSlider
        className={styles["horizontal-slider"]}
        min={0}
        max={3}
        defaultValue={3}
        /*markClassName=""*/
        thumbActiveClassName={styles.active}
        thumbClassName={styles["example-thumb"]}
        trackClassName={styles["example-track"]}
        /*renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}*/
        onChange={(value, index) => setFlags(value)}
    />
}


/**
 * renderTrack permette di customizzare il rendering dei 2 div utilizzati dallo slider (uno prima e uno dopo il "pallino")
 * N.B. il codice della <renderTrack> equivale al seguente css:
 * .example-track {
 * }
 *
 * div.example-track.example-track-0 {
 *     @apply rounded-md h-full bg-blue-300;
 * }
 *
 * @param setFlags
 * @constructor
 */
export const SliderPianificazione: React.FC<{
    setShowRiepiloghi: (value: boolean) => void,
    setShowCalendario: (value: boolean) => void,
    setShowOre: (value: boolean) => void,
    setShowTurno: (value: boolean) => void,
}> = ({setShowRiepiloghi, setShowCalendario, setShowOre, setShowTurno}) => {
    /*https://codesandbox.io/embed/simple-react-slider-56gsb?fontsize=14&hidenavigation=1&theme=dark*/
    // https://zillow.github.io/react-slider/
    // https://www.npmjs.com/package/react-slider
    const setFlags = (value: number) => {

        switch (value) {
            case 3:
                setShowRiepiloghi(true);
                setShowCalendario(true);
                setShowOre(true);
                setShowTurno(true);
                break;
            case 2:
                setShowRiepiloghi(true);
                setShowCalendario(false);
                setShowOre(true);
                setShowTurno(true);
                break;
            case 1:
                setShowRiepiloghi(true);
                setShowCalendario(false);
                setShowOre(false);
                setShowTurno(true);
                break;
            case 0:
                setShowRiepiloghi(false);
                setShowCalendario(false);
                setShowOre(false);
                setShowTurno(true);
                break;
        }
    }

    return <ReactSlider
        className="w-full h-2 pr-2 my-4 rounded-md cursor-grab bg-gray-300"
        min={0}
        max={3}
        defaultValue={3}
        /*markClassName=""*/
        thumbActiveClassName=""
        thumbClassName="absolute w-4 h-4 cursor-grab bg-blue-500 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 -top-1 thumb"
        trackClassName="pianificazione-track"
        renderTrack={({key, ...props}, state) => {
            if (state.index === 0) {
                return <div key={key} {...{...props, className: classNames(props.className, 'rounded-md h-full bg-blue-300')}} />
            } else {
                return <div key={key} {...props} />
            }
        }}
        /*renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}*/
        onChange={(value, index) => setFlags(value)}
    />
}
export default SliderPianificazione;